export default (theme) => ({
  row: {
    backgroundColor: theme.color.wheat,
  },
})
